import StoreUtil from '@/store/StoreUtil'

export default {
  SET_NOTIFICATIONS: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.notification,
    'setNotifications'
  ),
  REMOVE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.notification,
    'remove'
  ),
  ADD: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.notification, 'add'),
}
